import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {CURRENT_LANG} from '@app/core/token.storage';

/** Сервис параметров http-запроса */
@Injectable({
    providedIn: 'root'
})
export class HttpOptionsService {
    /** Объект заголовков */
    headers: HttpHeaders = null;
    readonly #window: Window = window;

    constructor() {
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'X-Current-Language': 'ru'
        });

        const lang = this.#window.window.sessionStorage.getItem(CURRENT_LANG);
        if (lang && this.headers.get('X-Current-Language') !== lang) {
            this.setLang(lang);
        }
    }

    /** Установить язык
     * @param lang обозначение текущего языка
     */
    public setLang(lang: string): void {
        if (lang) {
            this.headers = this.getCopyRequestHeaders({'X-Current-Language': lang});
        }
    }

    /** Получить измененные заголовки запроса
     * @param newHeaders новые заголовки запроса
     */
    public getCopyRequestHeaders(newHeaders: {[key: string]: string}): HttpHeaders {
        const oldHeaders = {};
        this.headers.keys().forEach((key: string) => {
            oldHeaders[key] = this.headers.get(key);
        });

        return new HttpHeaders(Object.assign(oldHeaders, newHeaders));
    }
}
